export default __webpack_public_path__ + "assets/windsock.d9375c49.svg";